module.exports = __webpack_public_path__ + "img/Slide16.fa6cb44c.png";